import { BpmnShapeType } from '@flowx/designer/modules/bpmn-editor/bpmn-graph.constants'
import { BoundaryEventType } from '@flowx/designer/shared/entities/boundary-event/boundary-event.common'
import { BoundaryEventEntity } from '@flowx/designer/shared/entities/boundary-event/boundary-event.entity'
import { NodeType } from '@flowx/designer/shared/entities/node.types'

export function isValidBoundaryEventDrop(
  targetNodeBPMNType: BpmnShapeType,
  targetNodeType: NodeType,
  dropNodeType: NodeType | BoundaryEventType
): boolean {
  const targetIsNode = targetNodeBPMNType === BpmnShapeType.BPMN_NODE

  return (
    targetIsNode &&
    BoundaryEventEntity.canCreateStandaloneBoundaryEventFromNode(dropNodeType as NodeType) &&
    BoundaryEventEntity.canAddBoundaryEventToNode(dropNodeType as BoundaryEventType, targetNodeType)
  )
}
